import GetWidgetJavaScriptUrlRequestModelBase from '../_generated/modelBases/get-widget-java-script-url-request-model-base';

export default class GetWidgetJavaScriptUrlRequestModel extends GetWidgetJavaScriptUrlRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
